export const isNil = (val: any) => val === null || val === undefined;
